import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
   query VimeoGetByIds ($videoID: Value, $limit: Int, $offset: Int, $value: Value) {
      VimeoGetByIds (videoID: $videoID, limit: $limit, offset: $offset, value: $value) {
        limit
        offset
        totalItems
        VimeoVideoInfos {
          ...vimeoVideoDetail
          FilmMastersFromVimeoID {
            ...vimeoIDMatchDetail
          }
          files {
            ...vimeoFileDetail
            FilmFilesFromMd5 {
              ...md5MatchDetail
            }
          }
          download {
            ...vimeoFileDetail
          }
          privacy {
            ...vimeoPrivacyDetail
          }
          pictures {
            ...vimeoPictureDetail
          }
          embed {
            html
          }
          metadata {
            connections {
              credits {
                ...vimeoMetadataDetail
              }
            }
          }
        }
      }
    }
    ${fragments.vimeoIDMatchDetail}
    ${fragments.md5MatchDetail}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmDetail}
    ${fragments.filmFileDetail}
    ${fragments.vimeoFileDetail}
    ${fragments.vimeoPrivacyDetail}
    ${fragments.vimeoPictureDetail}
    ${fragments.vimeoVideoDetail}
    ${fragments.vimeoMetadataDetail}
    ${fragments.filmMasterPosterFrames}
    ${fragments.filmHost}
    ${fragments.filmFiles}
    ${fragments.artworkDetails}
  `
